import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/icoContrast.png';
import _imports_1 from '@/assets/icoContrastOn.png';
import _imports_2 from '@/assets/icoFont.png';
import _imports_3 from '@/assets/icoFontM.png';
import _imports_4 from '@/assets/icoFontL.png';
var _hoisted_1 = {
  class: "accessibility"
};

var _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  width: "20",
  alt: "Privzeti barvni kontrast",
  src: _imports_0
}, null, -1);

var _hoisted_3 = {
  class: "padding-left5"
};

var _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  alt: "Prilagojen barvni kontrast",
  src: _imports_1
}, null, -1);

var _hoisted_5 = {
  class: "d-flex padding-left15 padding-bottom2",
  style: {
    "align-items": "flex-end"
  }
};
var _hoisted_6 = {
  class: ""
};

var _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "Privzeta velikosti pisave"
}, null, -1);

var _hoisted_8 = {
  class: "padding-left5"
};

var _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "Dvakratna velikosti pisave"
}, null, -1);

var _hoisted_10 = {
  class: "padding-left5"
};

var _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  alt: "Trikratna velikosti pisave"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", null, [_createVNode("a", {
    href: "",
    title: "Privzeti barvni kontrast",
    onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
      return _ctx.contrast(false);
    }, ["prevent"]))
  }, [_hoisted_2])]), _createVNode("div", _hoisted_3, [_createVNode("a", {
    href: "",
    title: "Prilagojen barvni kontrast",
    onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
      return _ctx.contrast(true);
    }, ["prevent"]))
  }, [_hoisted_4])]), _createVNode("div", _hoisted_5, [_createVNode("div", _hoisted_6, [_createVNode("a", {
    href: "",
    onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
      return _ctx.fontSize();
    }, ["prevent"])),
    title: "Privzeta velikosti pisave"
  }, [_hoisted_7])]), _createVNode("div", _hoisted_8, [_createVNode("a", {
    href: "",
    onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
      return _ctx.fontSize('M');
    }, ["prevent"])),
    title: "Dvakratna velikosti pisave"
  }, [_hoisted_9])]), _createVNode("div", _hoisted_10, [_createVNode("a", {
    href: "",
    onClick: _cache[5] || (_cache[5] = _withModifiers(function ($event) {
      return _ctx.fontSize('L');
    }, ["prevent"])),
    title: "Trikratna velikosti pisave"
  }, [_hoisted_11])])])]);
}